module.exports = require("./pa-Guru.d.ts");